_ = require('lodash')

module.exports = () ->

  NATIONAL_SUBDIVISION =
    id: 0
    name: 'Uncategorized'

  aggregate = (workers) ->
    grouped = _groupBySubdivision(workers)
    counted = _countResults(grouped)
    return _sortByName(counted)

  _countResults = (grouped) ->
    (items.reduce(_reduceAggregate, {count: 0}) for id, items of grouped)

  _reduceAggregate = (next, current) ->
    count: next.count + current.worker.results_available
    name: current.sub.name
    id: current.sub.id

  _sortByCount = (divs) ->
    divs.sort((div1, div2) -> div1.count < div2.count)

  _sortByName = (divs) ->
    divs.sort((div1, div2) -> div1.name.localeCompare(div2.name))

  _hasSubdivisions = (worker) ->
    subdivisions = workerSubdivisions(worker)
    return subdivisions.length > 0

  _getUnassociatedWorkers = (workers) ->
    workers.filter((worker) -> not _hasSubdivisions(worker))

  _decorateWithNational = (worker) ->
    if worker.engine
      worker.engine.subdivisions = [NATIONAL_SUBDIVISION]
    return worker

  _getNationalPairings = (workers) ->
    workers = _getUnassociatedWorkers(workers)
    workers = workers.map(_decorateWithNational)
    return _.flatten(workers.map(_makeWorkerSubdivisionPairings))

  _makeWorkerSubdivisionPairings = (worker) ->
    subdivisions = workerSubdivisions(worker)
    return subdivisions.map((sub) -> {worker: worker, sub: sub})

  _getWorkerSubdivisionPairings = (workers) ->
    pairings = workers.map(_makeWorkerSubdivisionPairings)
    pairings = _.flatten(pairings)
    pairings = pairings.concat(_getNationalPairings(workers))
    return pairings

  _groupBySubdivision = (workers) ->
    pairings = _getWorkerSubdivisionPairings(workers)
    groupingKey = (pair) -> pair.sub.id
    return _.groupBy(pairings, groupingKey)

  filterWorkers = (workers, include, exclude) ->
    workers.filter((worker) -> filterWorker(worker, include, exclude))

  intersects = (sub1, sub2) ->
    return _.intersection(sub1, sub2).length

  workerSubdivisions = (worker) ->
    if worker.engine
      return worker.engine.subdivisions
    return []

  filterWorker = (worker, include, exclude) ->
    subdivisions = workerSubdivisions(worker)
    ids = subdivisions.map((division) -> division.id)
    if include.length != 0
      return intersects(include, ids)
    if exclude.length != 0
      return !intersects(exclude, ids)
    return true

  aggregate: aggregate
  filterWorkers: filterWorkers
  filterWorker: filterWorker
  _getUnassociatedWorkers: _getUnassociatedWorkers
  _getNationalPairings: _getNationalPairings
  NATIONAL_SUBDIVISION: NATIONAL_SUBDIVISION
